import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { validate } from "../../helpers/validationRules";
import { patchVendor } from "../../patchers/vendor";
import { patchProfile } from "../../patchers/profile";
import { toast } from "react-toastify";

import * as _ from "lodash";
import { getLanguagesInputValue, useGetAvailableTranslation } from "../../hooks/global/Languages";


// TODO
function EditEntityField(props) {
  const { t } = useTranslation();

  const supportedLanguages = useGetAvailableTranslation();
  const defaultSupportedLanguages = getLanguagesInputValue('', supportedLanguages);
  const refFieldValue = useRef("fieldValue");
  const fieldName = props.fieldName;
  const compFieldValue = props.fieldValue;
  const fieldLabel = props.fieldLabel;
  const editType = props.editType;
  const compShowType = props.showType;
  const validations = props.validations;
  const entityId = props.entityId;
  const vendor = props.vendor;
  const entityName = props.entityName;
  const isMultilanguage = props.isMultilanguage;
  const onSuccess = props.onSuccess;
  const isDisabled = props.isDisabled;

  const [editing, setEditing] = useState(false);
  const [editable, setEditable] = useState(false);

  const [fieldValue, setFieldValue] = useState(_.cloneDeep(compFieldValue));
  const [errorShow, setErrorShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState(undefined);
  const [errorText, setErrorText] = useState(undefined);
  const [vendorLanguages, setVendorLanguages] = useState(
    _.intersection(supportedLanguages, vendor.languages)
  );
  const [errors, setErrors] = useState({
    input: _.cloneDeep(defaultSupportedLanguages),
    singleInput: "",
  });
  const [showType, setShowType] = useState(false);

  const isEditable = (vendorId) => {
    if (isDisabled) return false;
    let edit = false;
    let user = JSON.parse(localStorage.getItem("user"));
    if (user && user.vendor_ids && user.vendor_ids.length > 0) {
      user.vendor_ids.map((id) => {
        if (id === vendorId) {
          edit = true;
        }
      });
    }
    return edit;
  };

  useEffect(() => {
    if(props.fieldValue) setFieldValue(props.fieldValue)}, [props.fieldValue]);

  useEffect(() => {
    setEditable(isEditable(vendor.id));
    setShowType(isCheckbox());
  }, []);

  const startEdit = () => {
    setEditing(true);
  };

  const cancelEdit = () => {
    setEditing(false);
    setFieldValue(compFieldValue);
    setErrors({
      input: defaultSupportedLanguages,
      singleInput: "",
    });
  };

  const toogleFieldValueCheckbox = (fieldValue) => {
    if (typeof fieldValue == "boolean") return !fieldValue;
  };

  const isSubmitValid = () => {
    let isValid = true;
    vendorLanguages.forEach((lng) => {
      lng = lng.toUpperCase();
      if (errors.input.lng !== "") isValid = false;
    });
    if (errors.singleInput !== "") isValid = false;
    return isValid;
  };

  const isCheckbox = () => {
    return compShowType === "checkbox";
  };

  const editSubmit = (e) => {
    e.preventDefault();
    // if (!isSubmitValid()) return;

    let fValue = isCheckbox() ? e.target.checked : fieldValue;

    let payload = {};
    payload["fieldName"] = fieldName;
    payload["fieldValue"] = fValue;

    switch (entityName) {
      case "vendors":
        patchVendor(vendor.id, payload)
          .then(() => onSubmitSuccess(fValue))
          .catch((err) => {
            setErrorShow(true);
            setErrorTitle(t("err.edCo"));
            setErrorText(t(err));
          });
        break;
      case "profiles":
        patchProfile(entityId, vendor.id, payload)
          .then(() => onSubmitSuccess(fValue))
          .catch((err) => {
            setErrorShow(true);
            setErrorTitle(t("err.edCo"));
            setErrorText(t(err));
          });
        break;
    }
  };

  const onSubmitSuccess = (fieldValue) => {
    setFieldValue(fieldValue);
    setEditing(false);

    toast.success(t("toast.daCh"), {
      className: "successToast",
    });

    if (props.onSuccess) {
      props.onSuccess();
    }
  };

  const validateField = (value, lng) => {
    if (lng === undefined) lng = false;

    let inputLNG = lng || "SL";
    let isValid = true;
    setErrors({ input: "" });
    validations.forEach((rule) => {
      if (!validate(rule, value)) {
        let err = "err." + (rule === "required" ? "req" : "req");
        isMultilanguage
          ? setErrors({ input: t(err) })
          : setErrors({ singleInput: t(err) });
        isValid = false;
      }
    });
    setErrors({ errors: errors });
    return isValid;
  };

  const handleInputChange = (e, lng) => {
    if (lng === undefined) lng = false;
    let tmpValue = e.target.value;
    validateField(tmpValue, lng);
    tmpValue = e.target.value;
    lng ? (fieldValue[lng] = tmpValue) : setFieldValue(tmpValue);
  };

  const editComponent = () => {
    switch (editType) {
      case "textarea":
        return isMultilanguage ? (
          vendorLanguages.map((lng) => {
            return (
              <div className="langSelectInputWrap" key={lng}>
                <label>{lng}: </label>
                <div>
                  <textarea
                    autoFocus={true}
                    rows="4"
                    cols="50"
                    value={fieldValue[lng]}
                    onChange={(e) => handleInputChange(e, lng)}
                  />
                </div>
                {errors.input[lng] && (
                  <span className="validation">{t("err.req")}</span>
                )}
              </div>
            );
          })
        ) : (
          <div>
            <textarea
              autoFocus={true}
              rows="4"
              cols="50"
              value={fieldValue}
              onChange={(e) => handleInputChange(e)}
            />
            {errors.singleInput && (
              <span className="validation">{t("err.req")}</span>
            )}
          </div>
        );
      case "checkbox":
        return (
          <input
            type="checkbox"
            ref={refFieldValue}
            checked={fieldValue}
            onChange={(e) => {
              editSubmit(fieldValue);
            }}
          />
        );
      default:
        return isMultilanguage ? (
          vendorLanguages.map((lng) => {
            return (
              <div className="langSelectInputWrap" key={lng}>
                <label>{lng}: </label>
                <div>
                  <input
                    type="text"
                    autoFocus={true}
                    value={fieldValue[lng]}
                    onChange={(e) => handleInputChange(e, lng)}
                  />
                </div>
                {errors.input[lng] && (
                  <span className="validation">{t("err.req")}</span>
                )}
              </div>
            );
          })
        ) : (
          <div className="langSelectInputWrap">
            <input
              type="text"
              autoFocus={true}
              value={fieldValue}
              onChange={(e) => handleInputChange(e)}
            />
            {errors.singleInput && (
              <span className="validation">{t("err.req")}</span>
            )}
          </div>
        );
    }
  };

  const renderComponent = () => {
    switch (compShowType) {
      case "url":
        return (
          <a href={`https://${fieldValue}`} onClick={(event) => event.preventDefault()} target="_blank" rel="noopener noreferrer"> {fieldValue}</a>
        );
      case "checkbox":
        return (
          <div className="checkboxEntityField">
            <input
              id={fieldName + entityId}
              type="checkbox"
              ref={refFieldValue}
              checked={fieldValue}
              onChange={(e) => editSubmit(e)}
            />
            <label htmlFor={fieldName + entityId}>{fieldLabel}</label>
          </div>
        );
      default:
        return isMultilanguage ? (
          vendorLanguages.map((lng) => {
            return (
              <div key={lng}>
                <p onClick={() => startEdit(fieldName)}>
                  <span>{lng}: </span>
                  {fieldValue[lng]}
                  {!fieldValue[lng] && <span className="noTranslation" />}
                </p>
              </div>
            );
          })
        ) : (
          <p onClick={() => startEdit(fieldName)}>{fieldValue}</p>
        );
    }
  };
  return (
    <div>
      {" "}
      {editable ? (
        <div className="editEntity">
          {editing && !showType ? (
            <div className="editEntityForm">
              <div>
                <div className="editEntityFormInputWrap">
                  {editComponent(editType, fieldValue, validations)}
                  <button
                    onClick={editSubmit}
                    className="btn btn-default btn-confirm"
                  >
                    potrdi
                  </button>
                  <button
                    type="button"
                    className="btn btn-default btn-cancel"
                    onClick={() => cancelEdit()}
                  >
                    prekliči
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div
              onClick={() => startEdit(fieldName)}
              className="editEntityInner editEntityInnerUpdate"
            >
              {renderComponent()}
              {!showType && (
                <button
                  type="button"
                  className="btn btn-default btn-edit btn-editInput"
                  onClick={() => startEdit(fieldName)}
                >
                  uredi
                </button>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="groupOverview-listCustom">{renderComponent()}</div>
      )}
    </div>
  );
}

export default EditEntityField;
